import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';

export const templateCompanyDetailsForm = document.createElement('template');

templateCompanyDetailsForm.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='form-wrapper' id='company-details-form-wrapper'>
    <gz-title fontSize='11' fontWeight='600' class='form-subtitle' id='basic-details-subtitle'></gz-title>

    <div class='form-section'>
      <gz-form-field id='company-name-form-field' class='label-mw-250' label='' required>
        <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='company-type-form-field' class='label-mw-250 hidden' label='' required>
        <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <!-- Company Edit notices -->
      <gz-info-box severity='error' class='mb-2 hidden' id='company-type-partner-has-to-add-products-to-switch-to-customer-notice-container'></gz-info-box>

      <gz-info-box severity='error' class='mb-2 hidden' id='company-type-partner-has-managed-companies-notice-container'></gz-info-box>

      <gz-info-box severity='warning' class='mb-2 hidden' id='company-type-partner-will-lose-resell-addons-notice-container'></gz-info-box>

      <gz-info-box severity='warning' class='mb-2 hidden' id='company-type-partner-will-lose-mdr-reports-access-notice-container'></gz-info-box>

      <gz-info-box severity='warning' class='mb-2 hidden' id='company-type-customer-to-partner-reselling-notice-container'></gz-info-box>

      <gz-form-field id='company-customization-form-field' class='label-mw-250 hidden' label='' required>
        <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='country-form-field' class='label-mw-250' label='' required>
        <gz-dropdown gz-form-input localFiltering canDelete combobox type='dropdown'></gz-dropdown>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='state-form-field' class='label-mw-250 hidden' label='' required>
        <gz-dropdown gz-form-input localFiltering canDelete combobox type='dropdown'></gz-dropdown>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='industry-form-field' class='label-mw-250' label='' required>
        <gz-dropdown gz-form-input localFiltering canDelete combobox type='dropdown'></gz-dropdown>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='security-token-form-field' class='label-mw-250 hidden' label='' readonly>
        <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
      </gz-form-field>
    </div>

    <gz-title fontSize='11' fontWeight='600' class='form-subtitle' id='management-permissions-subtitle'></gz-title>
    <gz-text fontSize="14" id='management-permissions-subtitle-info-company'></gz-text>
    <gz-text class="pb-2" fontSize="14" id='management-permissions-subtitle-info-partner'></gz-text>

    <div class='form-section form-section-wide' id='management-permissions-form-section'>
      <gz-form-field id='manage-networks-form-field' class='mb-1'>
        <gz-checkbox gz-form-input label='' checked></gz-checkbox>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-info-box severity='warning' class='form-max-width mb-2 hidden' id='rights-warning-container'></gz-info-box>

      <gz-info-box severity='warning' class='form-max-width mb-2 hidden' id='company-type-partner-has-children-manage-network-disabled-notice-container'></gz-info-box>

      <gz-info-box severity='error' class='form-max-width mb-2 hidden' id='company-has-products-warning-container'></gz-info-box>


      <gz-form-field id='can-be-managed-by-above-form-field'>
        <gz-checkbox gz-form-input label='' checked></gz-checkbox>
        <gz-input-error></gz-input-error>
      </gz-form-field>
      <gz-form-field id='can-be-downloaded-by-above-form-field'>
        <gz-checkbox gz-form-input label=''></gz-checkbox>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='partner-has-redaction-active-form-field'>
        <gz-checkbox gz-form-input label='' checked></gz-checkbox>
        <gz-link type='underline' color='primary' id='partner-redaction-link' fontsize='12'></gz-link>
        <gz-input-error></gz-input-error>
      </gz-form-field>
    </div>

    <gz-title fontSize='11' fontWeight='600' class='form-subtitle' id='primary-account-subtitle'></gz-title>
    <gz-text fontSize="14" id='primary-account-subtitle-info'></gz-text>
    <gz-text class="pb-2" fontSize="14" id='primary-account-subtitle-description'></gz-text>

    <div class='form-section' id='primary-account-form-section'>
      <gz-form-field id='primary-account-full-name-form-field' class='label-mw-250' label=''>
        <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='primary-account-email-form-field' class='label-mw-250' label=''>
        <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='primary-account-timezone-form-field' class='label-mw-250' label=''>
        <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='primary-account-language-form-field' class='label-mw-250' label=''>
        <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
        <gz-input-error></gz-input-error>
      </gz-form-field>
    </div>

    <!-- MDR Contact Information Yearly -->
    <gz-mdr-contact-details-section class='hidden'></gz-mdr-contact-details-section>

    <!-- MDR Contact Information Monthly -->
    <gz-title fontSize='11' fontWeight='600' class='form-subtitle' id='contact-details-subtitle'></gz-title>

    <div class='form-section' id='contact-details-form-section'>
      <gz-form-field id='contact-full-name-form-field' class='label-mw-250' label='' required>
        <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='contact-email-form-field' class='label-mw-250' label='' required>
        <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='contact-role-form-field' class='label-mw-250' label='' required>
        <gz-dropdown gz-form-input type='dropdown' listPosition='top'></gz-dropdown>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='contact-role-other-form-field' class='label-mw-250 hidden' label='' required>
        <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='contact-phone-form-field' class='label-mw-250' label=''>
        <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>
    </div>

    <gz-title fontSize='11' fontWeight='600' class='form-subtitle' id='mdr-contact-details-subtitle'></gz-title>

    <div class='form-section' id='mdr-contact-details-form-section'>
      <gz-text class="pb-2" fontSize="14" id='mdr-contact-import-from-general-info-notice'></gz-text>
      <gz-button id='mdr-contact-import-from-general-info-button' class='pb-2' color='secondary' type='outline' buttonHeight='small' buttonFontSize='small'></gz-button>

      <gz-form-field id='mdr-contact-full-name-form-field' class='label-mw-250' label=''>
        <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-text fontSize="14" class='pt-2 pb-2' id='mdr-contact-email-verification-notice'></gz-text>
        <gz-form-field id='mdr-contact-email-form-field' class='label-mw-250' label=''>
            <div class='d-flex flex-row align-items-center'>
                 <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
                 <gz-button id='mdr-contact-verify-email-button' class='pl-1' type='quiet' buttonHeight='small' buttonFontSize='small'></gz-button>
            </div>
            <gz-input-error></gz-input-error>
        </gz-form-field>

      <gz-form-field id='mdr-contact-email-verification-code-form-field' class='label-mw-250' label=''>
        <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='mdr-contact-phone-form-field' class='label-mw-250' label=''>
        <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>
      <gz-text fontSize="14" class='pt-2' id='mdr-contact-cannot-change-notice'></gz-text>
    </div>

    <gz-title fontSize='11' fontWeight='600' class='form-subtitle' id='additional-details-subtitle'></gz-title>
    <gz-text class="pb-2" fontSize="14" id='additional-details-subtitle-info'></gz-text>

    <div class='form-section' id='additional-details-form-section'>
      <gz-form-field id='company-address-form-field' class='label-mw-250' label=''>
        <gz-textarea gz-form-input placeholder=''></gz-textarea>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='company-phone-form-field' class='label-mw-250' label=''>
        <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id='logo-form-field' class='label-mw-250' label=''>
        <div class='logo-img-container'>
          <img id='logo-img' class='logo-img hidden' alt='' />
        </div>
        <gz-file-input gz-form-input accept='image/png,image/jpg'>
          <gz-text class='logo-hint' id='logo-hint' fontSize="14"></gz-text>
          <div class='logo-buttons-container'>
            <gz-button
              id='logo-upload-button'
              browse-button
              type='quiet'
              color= 'primary'
              buttonHeight='small'
              buttonFontSize='small'
              lowercase='true'
            >
            </gz-button>

            <gz-button
              id='logo-reset-button'
              style='display: none;'
              type='quiet'
              color= 'primary'
              buttonHeight='small'
              buttonFontSize='small'
              lowercase='true'
            >
            </gz-button>
          </div>
        </gz-file-input>
      </gz-form-field>

      <gz-form-field id='logo-file-id-form-field' style='display: none;'>
        <gz-input gz-form-input type='text' inputWidth='240'></gz-input>
      </gz-form-field>
    </div>

    <gz-custom-fields-form class='hidden'></gz-custom-fields-form>

  </div>
`;
